import globals from "./global-variables";
import { ButtonText } from "./texts";
import { LeftArrowWhite, RightArrowWhite, StartOverIcon } from "./icons";

export const NavigationButton = {
  ...ButtonText,
  backgroundColor: globals.colors.black,
  border: `1px solid ${globals.colors.black}`,
  color: globals.colors.white,
  height: "48px",
  display: "flex",
  alignItems: "center",
  position: "relative",
  minWidth: "46px",
  "& .button-text": {
    display: "none"
  },
  cursor: "pointer"
};
export const NavigationBackButton = {
  ...NavigationButton,
  display: "flex",
  justifyContent: "center",
  "&:before": {
    ...LeftArrowWhite
  },
  [`@media (${globals.breakpoints.$md})`]: {
    minWidth: "160px",
    "& .button-text": {
      display: "inline",
      paddingLeft: "10px"
    }
  },
  [`@media (${globals.breakpoints.$xxs})`]: {
    marginRight: "10px"
  }
};
export const NavigationNextButton = {
  ...NavigationButton,
  display: "flex",
  justifyContent: "center",
  [`@media (${globals.breakpoints.$md})`]: {
    paddingRight: "20px",
    minWidth: "160px",
    "& .button-text": {
      display: "inline",
      paddingRight: "10px"
    }
  },
  [`@media (${globals.breakpoints.$xxs})`]: {
    marginLeft: "10px"
  },
  "&:after": {
    ...RightArrowWhite
  }
};

export const StartOverButton = {
  ...ButtonText,
  background: globals.colors.white,
  border: "none",
  color: globals.colors.darkBlack,
  height: "48px",
  position: "relative",
  width: "auto",
  minWidth: "100px",
  paddingRight: "30px",
  "&:after": {
    ...StartOverIcon
  },
  "&:hover, &:focus, &:active": {
    outline: "none",
    cursor: "pointer"
  }
};

export const AdviceNavigationButton = {
  ...ButtonText,
  backgroundColor: globals.colors.white,
  border: "none",
  display: "flex",
  position: "relative",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "32px",
  height: "32px",
  marginLeft: "3px",
  cursor: "pointer",
  "&:hover, &:focus, &:active": {
    outline: "none",
    cursor: "pointer"
  }
};
